import Vue from 'vue'

// In Vue 2.x, Vue.observable directly mutates the object passed to it, so that it is
// equivalent to the object returned, as demonstrated here. In Vue 3.x, a reactive proxy
//  will be returned instead, leaving the original object non-reactive if mutated directly.
// Therefore, for future compatibility, we recommend always working with the object
// returned by Vue.observable, rather than the object originally passed to it.
const initialState = {
    isAuthenticated: false,
    user: null,
    permissions: [],
}

export const authState = Vue.observable(initialState)

export function setAuthState(newState) {
    if (!newState) return

    Object.assign(authState, newState)
}
